import React from "react";
import ResetForm from "./ResetForm";
import { Actions } from "../../../core/modules/Actions";

const ResetCourseProgressForm = ({ onclickcancel = () => {}, onSuccess = () => {} }) => {
  return (
    <ResetForm
      onclickcancel={onclickcancel}
      onSuccess={onSuccess}
      title="Reset Student's Course Progress"
      buttonText="Reset Course Progress"
      placeholder="Enter student email address"
      onSubmitAction={Actions.students.resetCourseProgress}
    />
  );
};

export default ResetCourseProgressForm;
